$(() => {
  let wrapper = $(".manage-transition-years");
  if (!wrapper || !wrapper.length) return;

  $(".select-column").on("change", function () {
    $(this).closest("form").find("input.to_select[type=checkbox]").prop("checked", this.checked);
  });

  function onClickBox() {
    let checked = $("#transition_year").is(":checked");
    localStorage.setItem("checked", checked);
  }

  function onReady() {
    let checked = "true" === localStorage.getItem("checked"),
      elTransitionYear = $("#transition_year");

    elTransitionYear.prop("checked", checked);
    elTransitionYear.on("click", onClickBox);
  }

  let elemCheckbox = $(".to_select, .select-column");

  elemCheckbox.on("change", function () {
    let dataTrue = 0,
      elButton = $("#doing_transition_year, #not_doing_transition_year");

    for (let i = 0; i < elemCheckbox.length; i++) {
      if (elemCheckbox[i].checked) {
        dataTrue++;
      }
    }

    if (dataTrue > 0) {
      elButton.attr("disabled", false);
    } else {
      elButton.attr("disabled", true);
    }
  });

  $("tr input[name='transition_year']").on("change", function () {
    let el = $(this),
      elChecked = !el.prop("checked"),
      confirm = window.confirm("Are you sure?");

    if (confirm === false) {
      $(el).prop("checked", elChecked);
    }
  });

  $(document).on("ready", onReady);

  $("#student_name_select_ty", wrapper).select2({
    placeholder: "- Filter by student -",
    ajax: { dataType: "json", url: "/student_entities/autocomplete", delay: 250 },
  });

  $("#student_year_select_ty", wrapper).select2({
    placeholder: "- Filter by year group -",
    minimumResultsForSearch: Infinity,
  });

  $("#transition_year", wrapper).select2({
    minimumResultsForSearch: Infinity,
  });

  $("#school_id", wrapper).select2({
    placeholder: "- Filter by school -",
    minimumResultsForSearch: Infinity,
  });
});
